const childRoutes = (prop) => [
    {
        path: 'assistive-device-application',
        name: prop + '.assistive_device_application',
        meta: { auth: true },
        component: () => import('../pages/assistive-device-application/List.vue')
    },
    {
        path: 'demand-collection-list',
        name: prop + '.demand_collection_list',
        meta: { auth: true },
        component: () => import('../pages/demand-collection-list/List.vue')
    },
    {
        path: 'budget-prepare-list',
        name: prop + '.budget_prepare_list',
        meta: { auth: true },
        component: () => import('../pages/budget-prepare/List.vue')
    },
    {
        path: 'fund-recieved-entry',
        name: prop + '.fund_recieved_entry',
        meta: { auth: true },
        component: () => import('../pages/fund-recieved-entry/List.vue')
    },
    {
        path: 'budget-prepare-form',
        name: prop + '.budget_prepare_list',
        meta: { auth: true },
        component: () => import('../pages/budget-prepare/Form.vue')
    },
    {
        path: 'budget-prepare-details',
        name: prop + '.budget_prepare_details',
        meta: { auth: true },
        component: () => import('../pages/budget-prepare/Details.vue')
    },
    {
        path: 'challan-generate',
        name: prop + '.challan_generate',
        meta: { auth: true },
        component: () => import('../pages/challan-generate/List.vue')
    },
    {
        path: 'recieve-against-purchase-order',
        name: prop + '.recieve_against_purchase_order',
        meta: { auth: true },
        component: () => import('../pages/recieve-against-purchase-order/List.vue')
    },
    {
      path: 'recieve-against-purchase-order-form',
      name: prop + '.recieve_against_purchase_order_list',
      meta: { auth: true },
      component: () => import('../pages/recieve-against-purchase-order/Form.vue')
    },
    {
      path: 'recieve-against-purchase-order-details',
      name: prop + '.recieve_against_purchase_order_details',
      meta: { auth: true },
      component: () => import('../pages/recieve-against-purchase-order/Details.vue'),
      props: true
    },
    {
        path: 'stock-in',
        name: prop + '.stock_in',
        meta: { auth: true },
        component: () => import('../pages/stock-in/List.vue')
    },
    {
        path: 'stock-out-requisition',
        name: prop + '.stock_out_requisition',
        meta: { auth: true },
        component: () => import('../pages/stock-out-requisition/List.vue')
    },
    {
        path: 'stock-in-details',
        name: prop + '.stock_in_details',
        meta: { auth: true },
        component: () => import('../pages/stock-in/details.vue')
    },
    {
        path: 'stock-in-form',
        name: prop + '.stock_in_form',
        meta: { auth: true },
        component: () => import('../pages/stock-in/Form.vue')
    },
    {
        path: 'stock-out-requisition-form',
        name: prop + '.stock_out_requisition_form',
        meta: { auth: true },
        component: () => import('../pages/stock-out-requisition/Form.vue')
    },
    {
        path: 'stock-out-requisition-approval-form',
        name: prop + '.stock_out_requisition_approval_form',
        meta: { auth: true },
        component: () => import('../pages/stock-out-requisition-approval/Form.vue')
    },
    {
        path: 'stock-out-requisition-approval',
        name: prop + '.stock_out_requisition_approval',
        meta: { auth: true },
        component: () => import('../pages/stock-out-requisition-approval/List.vue')
    },
    {
        path: 'purchase-order-list',
        name: prop + '.purchase_order_list',
        meta: { auth: true },
        component: () => import('../pages/purchase-order/List.vue')
    },
    {
        path: 'purchase-order-form',
        name: prop + '.purchase_order_form',
        meta: { auth: true },
        component: () => import('../pages/purchase-order/Form.vue')
    },
    {
        path: 'purchase-order-details',
        name: prop + '.purchase_order_details',
        meta: { auth: true },
        component: () => import('../pages/purchase-order/Details.vue')
    },
    {
        path: 'distributed-purchase-order',
        name: prop + '.distributed_purchase_order',
        meta: { auth: true },
        component: () => import('../pages/distributed-purchase-order/List.vue')
    },
    {
        path: 'distributed-purchase-order-form',
        name: prop + '.distributed_purchase_order_form',
        meta: { auth: true },
        component: () => import('../pages/distributed-purchase-order/Form.vue')
    },
    {
      path: 'distributed-purchase-order-details',
      name: prop + '.distributed_purchase_order_details',
      meta: { auth: true },
      component: () => import('../pages/distributed-purchase-order/Details.vue')
    },
    {
        path: 'donation-receive',
        name: prop + '.donation_receive',
        meta: { auth: true },
        component: () => import('../pages/donation-receive/List.vue')
    },
    {
        path: 'bill-generate',
        name: prop + '.bill_generate',
        meta: { auth: true },
        component: () => import('../pages/bill-generate/List.vue')
    },
    {
        path: 'bill-generate-form',
        name: prop + '.bill_generate_list',
        meta: { auth: true },
        component: () => import('../pages/bill-generate/Form.vue')
    },
    {
        path: 'bill-generate-details',
        name: prop + '.bill_generate_details',
        meta: { auth: true },
        component: () => import('../pages/bill-generate/Details.vue'),
        props: true
    },
    {
        path: 'psosk-demand-list',
        name: prop + '.psosk_demand_list',
        meta: { auth: true },
        component: () => import('../pages/psosk-demand/List.vue')
    },
    {
        path: 'psosk-demand-form',
        name: prop + '.psosk_demand_form',
        meta: { auth: true },
        component: () => import('../pages/psosk-demand/Form.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/assistive-device-management',
    name: 'awareness_event_service.assistive_device_management',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.assistive_device_management')
}]

export default routes
